export const SERVICE_REMOVAL_NAME = 'serviceRemoval';
export const SERVICE_REMOVAL_URL = 'serviceremoval';
export const SERVICE_REMOVAL_NAME_GIS = 'ServiceAbandonment';
export const SERVICE_REMOVAL_NAME_APLLICATION_TYPE = 'Abandonment';
export const NEW_GAS_LINE_NAME = 'newGasLine';
export const NEW_GAS_LINE_URL = 'newgasline';
export const NEW_GAS_LINE_NAME_GIS = 'NewServiceAttachment';
export const NEW_GAS_LINE_NAME_APLLICATION_TYPE = 'New Service Attachment';
export const REGEX_POSTALCODE =/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
export const REGEX_PHONENO = /\d{3}-\d{3}-\d{4}/;
export const REGEX_BN = /^[0-9]{9}$/;
export const REGEX_PASSWORD = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$/;
export const REGEX_EMAIL = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const REGEX_DATE = /^(\d{4})(\/)(\d{1,2})(\/)(\d{1,2})$/g;
export const REGEX_TWO_DECIMAL = /^(?=.*\d)\d*(?:\.\d\d)?$/;